<template>
  <div class="titleBg">
    <div class="left">dd</div>
    <div class="right">
      <el-avatar icon="el-icon-user-solid"></el-avatar>
      <el-dropdown :hide-on-click="false">
        <span class="el-dropdown-link">
          用户名<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxHeader",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.titleBg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: rgba(90, 146, 173);
}
.left {
  color: #ffffff;
  margin-left: 20px;
}
.right {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.text1 {
  text-decoration: none;
  font-size: 20px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
  margin: 0 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/BoxHeader.vue